import { useCallback, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';
import { SessionTimeoutDialog } from '@/components/SessionTimeoutDialog';
import { toast } from 'sonner';

export function SessionTimeoutManager() {
  const { user, signOut } = useAuth();
  const toastIdRef = useRef<string | number | null>(null);

  const handleTimeout = useCallback(async () => {
    // Sulje mahdollinen toast
    if (toastIdRef.current) {
      toast.dismiss(toastIdRef.current);
    }
    
    // signOut() hoitaa ohjauksen window.location.href = "/auth" kautta
    await signOut();
    
    toast.info('Istuntosi on vanhentunut', {
      description: 'Kirjaudu sisään jatkaaksesi.',
    });
  }, [signOut]);

  const handleWarning = useCallback(() => {
    // Näytä toast-varoitus 5 min kohdalla
    toastIdRef.current = toast.warning('Istuntosi vanhenee pian', {
      description: 'Istunto katkeaa 5 minuutin kuluttua inaktiivisuuden vuoksi.',
      duration: 10000,
    });
  }, []);

  const timeout = useSessionTimeout({
    onTimeout: handleTimeout,
    onWarning: handleWarning,
  });

  // Älä renderöi mitään jos käyttäjä ei ole kirjautunut
  if (!user) {
    return null;
  }

  return (
    <SessionTimeoutDialog
      open={timeout.showWarningDialog}
      remainingSeconds={Math.ceil(timeout.remainingTime / 1000)}
      onExtend={timeout.extendSession}
      onLogout={timeout.logout}
    />
  );
}
